import { ID_DESCRIPTION_ATTRIBUTE } from '@shared/constants/keys';
import { useAppSelector } from '@shared/hooks/redux';

import { Caption } from '../Caption/Caption';
import { EmptyState } from '../EmptyState/EmptyState';
import cls from './Description.module.scss';

export const Description = () => {
  const description = useAppSelector((state) => state.product.data.props[ID_DESCRIPTION_ATTRIBUTE]);

  const text = description?.values.map((el) => el.value).join(',');

  if (!description?.values?.length) {
    return <EmptyState />;
  }

  return (
    <div className={cls.wrap}>
      <Caption>Описание</Caption>
      {text && (
        <div
          className={cls.text}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}
    </div>
  );
};
